// Shared tool/tab definitions for the project workspace.
// Consumed by both the AppShell sidebar and ProjectHub so they never drift.

export type ToolId =
  | 'overview' | 'facility' | 'dalt' | 'ebtron' | 'power' | 'powerFactor'
  | 'boiler' | 'pmScheduler' | 'compliance' | 'documents' | 'assistant';

export type ToolGroup = 'workspace' | 'calc' | 'manage';

export interface ToolDef {
  id: ToolId;
  label: string;
  group: ToolGroup;
}

/* Order within each group is the display order in the sidebar. Icons are not here: this used
   to carry bootstrap-icon class names that nothing read — AppShell maps ToolId to AntD icons
   in TOOL_ICONS — and they became actively misleading once bootstrap-icons was dropped. */
export const TOOLS: ToolDef[] = [
  { id: 'overview',     label: 'Project Hub',    group: 'workspace' },
  { id: 'documents',    label: 'Documents',      group: 'workspace' },
  { id: 'boiler',       label: 'Boiler ECM',     group: 'calc' },
  { id: 'power',        label: 'Power',          group: 'calc' },
  { id: 'powerFactor',  label: 'Power Factor',   group: 'calc' },
  { id: 'ebtron',       label: 'Ebtron Airflow', group: 'calc' },
  { id: 'dalt',         label: 'DALT',           group: 'calc' },
  { id: 'facility',     label: 'Facility',       group: 'manage' },
  { id: 'pmScheduler',  label: 'PM Scheduler',   group: 'manage' },
  { id: 'compliance',   label: 'Compliance',     group: 'manage' },
  { id: 'assistant',    label: 'Building Assistant', group: 'manage' },
];

export const GROUP_LABELS: Record<ToolGroup, string> = {
  workspace: 'Workspace',
  calc: 'Calculation Tools',
  manage: 'Management',
};

// An org may restrict which modules are enabled. overview is always available.
export const isToolEnabled = (id: ToolId, enabledModules?: string[]): boolean =>
  id === 'overview' || !enabledModules || enabledModules.includes(id);
